/**
 * Date utilities for spaced repetition scheduling and display.
 */

/**
 * Get today's date as ISO date string (YYYY-MM-DD), no time component.
 */
export function today() {
  return new Date().toISOString().split('T')[0];
}

/**
 * Add days to a date string, return ISO date string.
 */
export function addDays(dateStr, days) {
  const date = new Date(dateStr + 'T00:00:00');
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
}

/**
 * Check if a date string is today or in the past (i.e., the card is due).
 */
export function isDueToday(dateStr) {
  if (!dateStr) return true; // No review date means it's new and due
  return dateStr <= today();
}

/**
 * How many days overdue is this card? (0 = due today, negative = not yet due)
 */
export function daysOverdue(dateStr) {
  if (!dateStr) return 0;
  const dueDate = new Date(dateStr + 'T00:00:00');
  const now = new Date(today() + 'T00:00:00');
  return Math.floor((now - dueDate) / (1000 * 60 * 60 * 24));
}

/**
 * Format a date string for display (e.g., "Apr 8, 2026")
 */
export function formatDate(dateStr) {
  if (!dateStr) return 'Never';
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Format seconds into a human-readable duration (e.g., "2m 15s")
 */
export function formatDuration(totalSeconds) {
  if (!totalSeconds || totalSeconds < 1) return '0s';
  const m = Math.floor(totalSeconds / 60);
  const s = Math.floor(totalSeconds % 60);
  if (m === 0) return `${s}s`;
  if (s === 0) return `${m}m`;
  return `${m}m ${s}s`;
}
